import { ReactElement } from 'react';
import { getSchema } from '@localstack/services';
import { EC2SecurityGroup } from '@localstack/types';

import { MagicDetails } from '../../magic/MagicDetails';

export interface SecurityGroupDetailsProps {
  securityGroup?: Optional<Partial<EC2SecurityGroup>>;
}

export const SecurityGroupDetails = ({ securityGroup }: SecurityGroupDetailsProps): ReactElement => (
  <MagicDetails
    data={securityGroup}
    schema={getSchema('EC2')}
    entry="SecurityGroup"
    title="Security Group Details"
    order={['GroupId', 'GroupName', 'Description', 'VpcId', 'OwnerId', 'IpPermissions', 'IpPermissionsEgress', 'Tags']}
  />
);
